import { Button, Col, Container, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { useEffect, useState } from "react";
import { useAuth } from "authContext";
import api from "common/api";
import { useParams } from "react-router-dom";
import CourseNews from "../CourseNews/CourseNews";
import { ICourse, IStudentInfoInCourse } from "common/types";
import RemoveStudentModal from "./RemoveStudentModal";
import { BsFillTrash3Fill } from "react-icons/bs";
import CourseFiles from "../CourseFiles/CourseFiles";
import AppointmentsCalendar from "../AppointmentsCalendar/AppointmentsCalendar";
import usePageTitle from "common/usePageTitle";
import { s3_url } from "common/constants";

function CoursePage() {
  const { id } = useParams();
  const { userProfile } = useAuth();
  const [course, setCourse] = useState<ICourse>({} as ICourse);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [studentToRemove, setStudentToRemove] = useState(null);

  usePageTitle("Grupa");

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const response = await api.get(`/courses/${id}/`);
        setCourse(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCourse();
  }, [id]);

  const removeStudent = async () => {
    try {
      await api.post(`/courses/${id}/remove-student/`, {
        user_ids: [studentToRemove],
      });
      setCourse({
        ...course,
        students: course.students.filter(
          (student) => student.user_id !== studentToRemove,
        ),
      });
      setShowRemoveModal(false);
      toast.success("Učenik uklonjen iz grupe");
    } catch (error) {
      console.error(error);
      toast.error("Greška prilikom uklanjanja učenika iz grupe");
    }
  };

  const studentColumns = [
    {
      name: "Ime",
      selector: (row: IStudentInfoInCourse) => row.first_name,
      sortable: true,
    },
    {
      name: "Prezime",
      selector: (row: IStudentInfoInCourse) => row.last_name,
      sortable: true,
    },
    {
      name: "Škola",
      selector: (row: IStudentInfoInCourse) => row.profile?.school,
      sortable: true,
    },
    {
      name: "Mail",
      selector: (row: IStudentInfoInCourse) => row.email,
      sortable: true,
    },
    {
      button: true,
      cell: (row: any) =>
        userProfile?.role === "PRINCIPAL" && (
          <BsFillTrash3Fill
            style={{ color: "darkred", cursor: "pointer" }}
            onClick={() => {
              setStudentToRemove(row.user_id);
              setShowRemoveModal(true);
            }}
            title={"Ukloni učenika iz grupe"}
          />
        ),
    },
  ];

  return (
    <div>
      <Container fluid>
        <Row className="align-items-center mb-3">
          <Col xs={6} md={3}>
            <img
              style={{
                width: "100%",
                maxWidth: "250px",
                height: "auto",
                borderRadius: "10px",
              }}
              src={course.teachers && course.teachers[0].profile?.picture}
              alt="Slika nastavnika"
            />
          </Col>
          <Col xs={6} md={6}>
            <h4>Grupa: {course.title}</h4>
            <h4>Termin: {course.times}</h4>
            {course.teachers && course.teachers[0] && (
              <h4>
                Nastavnik:{" "}
                {course.teachers[0].first_name +
                  " " +
                  course.teachers[0].last_name}
              </h4>
            )}
          </Col>
          <Col xs={6} md={3} className="d-flex justify-content-center">
            <img
              style={{ width: "100%" }}
              src={
                (course.subject && course.subject.picture) ||
                `${s3_url}/lumen_kauc.png`
              }
              alt="Lumenko logo"
            />
          </Col>
        </Row>
      </Container>

      {userProfile?.role !== "STUDENT" && (
        <>
          <Row className="align-items-center justify-content-between">
            <Col>
              <h4>Učenici</h4>
            </Col>
            <Col className="text-end">
              {course.students && course.students.length > 0 && (
                <Button
                  variant="outline-primary"
                  onClick={() => {
                    const emails = course.students
                      .map((student) => student.email)
                      .join(", ");
                    navigator.clipboard
                      .writeText(emails)
                      .then(() => {
                        toast.success("Emailovi kopirani");
                      })
                      .catch((error) =>
                        console.error("Could not copy text: ", error),
                      );
                  }}
                >
                  Kopiraj emailove učenika
                </Button>
              )}
            </Col>
          </Row>

          <DataTable
            columns={studentColumns}
            data={course.students}
            pagination
            noDataComponent="Trenutno nema učenika u grupi"
          />
        </>
      )}
      <CourseNews course={course} setCourse={setCourse} />

      <Row className="justify-content-center">
        <Col xl={8}>
          {course && course.id && (
            <div className="mb-3">
              <AppointmentsCalendar course={course} />
            </div>
          )}
        </Col>
      </Row>

      <div className="mb-3">
        <CourseFiles course={course} setCourse={setCourse} />
      </div>

      <RemoveStudentModal
        show={showRemoveModal}
        onHide={() => setShowRemoveModal(false)}
        onConfirm={removeStudent}
      />
    </div>
  );
}

export default CoursePage;
